/**
 * Format time string to HH:MM for display.
 * Strips seconds if present (handles HH:MM:SS from database).
 */
export function formatTimeDisplay(time: string): string {
  if (!time) return '';
  const parts = String(time).split(':');
  return `${parts[0] ?? '00'}:${parts[1] ?? '00'}`;
}

/**
 * Format duration in minutes for display (e.g. 60 -> "1h", 90 -> "1h30", 30 -> "30 min").
 */
export function formatDurationMinutes(minutes: number): string {
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h${m.toString().padStart(2, '0')}` : `${h}h`;
}
